import { createContext, useContext } from 'react';
import { IBill } from '../../../../models/Bills.interfaces';
import { AxiosError } from 'axios';

type BillsContextType = {
    bills: IBill[];
    billsToDownload: Set<string>;
    isDownloadCompleted: boolean;
    billsDownloaded: string[];
    billsWithError: string[];
    downloadError: AxiosError | null;
    billsZip: Blob | null;
    setBills: (value: IBill[]) => void;
    setBillsToDownload: (value: Set<string>) => void;
    setIsDownloadCompleted: (value: boolean) => void;
    setBillsDownloaded: (value: string[]) => void;
    setBillsWithError: (value: string[]) => void;
    setDownloadError: (value: AxiosError | null) => void;
    setBillsZip: (value: Blob | null) => void;
};

export const BillsContext = createContext({} as BillsContextType);

export const useBillsContext = () => {
    const context = useContext(BillsContext);

    if (!context) throw new Error('useBillsContext must be used within a BillsProvider');

    return context;
};
